import { render, staticRenderFns } from "./EditPageAdminManager.vue?vue&type=template&id=4f51d878"
import script from "./EditPageAdminManager.vue?vue&type=script&lang=js"
export * from "./EditPageAdminManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports